import { useMyTasks } from '../messaging/useWorkflows.ts'

export interface NeedsYouItem {
  key: string
  /** "3 overdue tasks" */
  label: string
  /** Where doing it starts. */
  to: string
  tone: 'danger' | 'warning' | 'brand'
}

/**
 * What is waiting on this person, one tap each, for the top of the
 * dashboard: overdue tasks, or tasks to do. (Setup left to finish has its
 * own checklist there.)
 */
export function useNeedsYou(): NeedsYouItem[] {
  const tasks = useMyTasks()
  const items: NeedsYouItem[] = []
  if (tasks.overdue.length > 0)
    items.push({
      key: 'overdue',
      label: `${tasks.overdue.length} overdue ${tasks.overdue.length === 1 ? 'task' : 'tasks'}`,
      to: '/tasks',
      tone: 'danger',
    })
  else if (tasks.upcoming.length > 0)
    items.push({
      key: 'tasks',
      label: `${tasks.upcoming.length} ${tasks.upcoming.length === 1 ? 'task' : 'tasks'} to do`,
      to: '/tasks',
      tone: 'brand',
    })
  return items
}
